<template>
  
    <div>
      

                    <div v-for="(airline, index) in options" :key="index"
                    :class="(airline.status==1 && airline.by=='default') || 
                    (airline.status==0 && airline.by=='user') ?'uncheck':null" class="blue-cus-checkbox">
                     
                      <input :id="'obAl'+index"
                        type="checkbox" :checked='airline.status==1 && airline.by=="user"' 
                       
                         v-on:input="onEmitSelAL(airline)"  class="d-none"
                        
                      />
                     
                      <label :for="'obAl'+index" > <img class=" flight-det-logo" v-if='GET_AIRLINES && GET_AIRLINES[airline.code] && GET_AIRLINES[airline.code].logourl'
                                :src="GET_AIRLINES[airline.code].logourl||defaultALImg" alt width="20px"
                        />
                        <img class=" flight-det-logo" v-else
                                :src="defaultALImg" alt width="20px"
                        /> {{ airline.name }}</label> 
                    </div>
                     <!-- :disabled='(airline.status==1 && airline.by=="default") || 
                        (airline.status==0 && airline.by=="user")' -->
    </div>
 
</template>

<script>
import router ,{navigate,goBack }from "../../router/index";
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";

import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME,FILTER } from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
export default {
  name: COMPONENT_NAME.C_FILTER_AL_OB,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {  
    prop: "selValue"
  },
  props: {
    
      filterObWatList: {
      type: Object
    }
   
  },
  data: () => ({
    options: [],
    selectedAirline:[],
    selValueModel: [],
    selALNameLs:[],
    filterObWatchList:{},
    defaultALImg: BaseConfiguration.defaultALImg,
  }),

  watch: {
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    },
     filterObWatList:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
      
      if(oldVal==newVal||oldVal!=newVal){
       this.filterObWatchList = this.filterObWatList;
       this.selValueModel=this.filterObWatchList[FILTER.C_FILTER_AL];
     
       this.options =this.filterObWatchList[FILTER.C_FILTER_AL];
       
   
      // if(this.selValueModel.length>0){
      //   for(let i=0;i<this.selValueModel.length;i++)
      //   {
      //  this.selALNameLs.push( this.selValueModel[i].airline_name);
      // this.selectedAirline.push(this.selValueModel[i]);
      
      //   }

      // }
    }
        
      }
      },
    // filterWatList(val){
    //   if (val !== this.filterWatList) {
      
    //   }

    // }
    // flightRes:{
    //     immediate: false, 
    //     deep: true,
    // handler: function (newVal, oldVal) {
      
    //   if(oldVal==newVal){
    //    this.onEmitSelAL(this.selValueModel);
    // }
        
    //   }
    //   },
     
  },

  async created() {
    // console.log(this.flightRes);
    
    try {
      if (BaseConfiguration.isDebug) console.log(" created");
      this.filterObWatchList=this.filterObWatList;
      this.selValueModel=this.filterObWatchList[FILTER.C_FILTER_AL];
      
     

      // //  this.selValueModel= Object.values(this.airlines);
      // let flightAirlines = this.airlines;
       this.options =this.filterObWatchList[FILTER.C_FILTER_AL];
       
      // if(!this.selValueModel) {
      //   this.selValueModel= this.options;
      // }
     
      // console.log(flightAirlines);
      // for(let i=0;i<this.selValueModel.length;i++){
      //   for (let index = 0; index < Object.keys(this.airlines).length;index++ ) {
      //  if(Object.values(this.airlines)[index].airline_name==this.selValueModel[i].airline_name){
      //    this.selValueModel[i].code=Object.keys(this.airlines)[index];
      
      //  break;
      //  }
       
      //  }
     
      // }
      if(this.selValueModel.length>0){
        for(let i=0;i<this.selValueModel.length;i++)
        {
       this.selALNameLs.push( this.selValueModel[i].name);
      this.selectedAirline.push(this.selValueModel[i]);
      
        }

      }
      
      
      
      if (BaseConfiguration.isDebug) console.log(this.selValueModel)
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_FILTER_AL,
        "error while Component created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    // }
  },

  computed: {
    ...mapGetters("sResult", {
      GET_AIRLINES: 'GET_AIRLINES',
     
    })
  },

  methods: {
    onEmitSelAL(pselValueModel) {
      let retValue;
    
      try {
     for(let i=0;i<this.selectedAirline.length;i++){ 
       if(this.selectedAirline[i].name==pselValueModel.name){
         if(this.selectedAirline[i].by=='default' && this.selectedAirline[i].status==1) {
                                this.selectedAirline[i].by='user';
                                this.selectedAirline[i].status=1
                            }else{
         this.selectedAirline[i].by=='user'?this.selectedAirline[i].by='default':this.selectedAirline[i].by='user';
         this.selectedAirline[i].status==0? this.selectedAirline[i].status=1: 
         this.selectedAirline[i].status=0;
                            }
       }
       }
      //  console.log(this.selectedAirline);
      //  if(this.selectedAirline.length>0){
      //    let isDup=false;
      //    let dulIndex=null;
       
      //   for(let i=0;i<this.selectedAirline.length;i++){ 
      //  if(this.selectedAirline[i].airline_name==pselValueModel.airline_name){
      //    isDup=true;
      //    dulIndex=i;
      //  }
      //  }
      //   if(isDup){
      //           this.$delete(this.selectedAirline,dulIndex);

      //  }else{
      //   this.selectedAirline.push(pselValueModel); 
      //  }
      //  }else{
      //   this.selectedAirline.push(pselValueModel);

      //  }

    // retValue=this.filterObAL(Object.values(this.flightResponse), this.selectedAirline);
    
              this.$emit('input', this.selectedAirline,FILTER.C_FILTER_AL);

         
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_FILTER_AL,
          "error while onEmitSelAL",
          err.toString(),
          "onEmitSelAL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
  },

  },
 
};
</script>
<style scoped>
.uncheck {
        background-color: rgb(255, 254, 254);
    }
        .flight-det-logo{
    border-radius: 50%;
}
</style>
